import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import { useCarModelsStore } from '@/stores/dictionary/car-models';
import { CarModelResource } from '@shared/resources/car-model';
import { getCarName } from '../../../helpers/cars';
import { computed } from 'vue';

interface Emits {
  (e: 'update:modelValue', value?: CarModelResource): void;
}

interface Props {
  modelValue?: CarModelResource;
  dropdownHeight?: number;
  hideEmpty?: boolean;
  errors?: string|string[];
  searchPlaceholder?: string;
  selectOptionText?: string;
  deselectOptionText?: string;
  noOptionsText?: string,
  disabled?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CarSelect',
  props: {
    modelValue: null,
    dropdownHeight: null,
    hideEmpty: { type: Boolean },
    errors: null,
    searchPlaceholder: null,
    selectOptionText: null,
    deselectOptionText: null,
    noOptionsText: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  modelValue?: CarModelResource;
  dropdownHeight?: number;
  hideEmpty?: boolean;
  errors?: string|string[];
  searchPlaceholder?: string;
  selectOptionText?: string;
  deselectOptionText?: string;
  noOptionsText?: string,
  disabled?: boolean;
}



const carsStore = useCarModelsStore();

const manager = useSelectClientDataManager({
  data: computed(() => carsStore.data),
  hideSelected: true,
  selected: computed(() => props.modelValue),
  customSearch(option: CarModelResource, search) {
    const value = getCarName(option).toLowerCase();
    const values = value.split(' ');

    const searches = search.split(' ');

    if (searches.length === 1) {
      return value.includes(search);
    }
    return (values[0].includes(searches[0]) && values[1].includes(searches[1]))
        || (values[0].includes(searches[1]) && values[1].includes(searches[0]));
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SingleSelect), {
    "data-manager": _unref(manager),
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    "select-option-text": __props.selectOptionText || _ctx.$t('pages.common.select-car-model'),
    "search-placeholder": __props.searchPlaceholder,
    "hide-empty": __props.hideEmpty,
    "no-options-text": __props.noOptionsText,
    "dropdown-height": __props.dropdownHeight,
    "deselect-option-text": __props.deselectOptionText,
    disabled: __props.disabled,
    errors: __props.errors
  }, {
    "selected-option": _withCtx(({ value }) => [
      _createTextVNode(_toDisplayString(_unref(getCarName)(value)), 1)
    ]),
    option: _withCtx(({ option }) => [
      _createTextVNode(_toDisplayString(_unref(getCarName)(option)), 1)
    ]),
    _: 1
  }, 8, ["data-manager", "model-value", "select-option-text", "search-placeholder", "hide-empty", "no-options-text", "dropdown-height", "deselect-option-text", "disabled", "errors"]))
}
}

})